import { Component, OnInit } from '@angular/core';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { faEdit, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-vehicle-make-list',
    templateUrl: './vehicle-make-list.component.html',
    styleUrls: ['./vehicle-make-list.component.scss'],
    standalone: false
})
export class VehicleMakeListComponent implements OnInit {
  vehicleMakeForm: FormGroup;
  showEditMakePopup: boolean = false;
  makeId!: string;
  makeList: any[] = [];
  filters:any={
    page:0
  }
  protected faEdit = faEdit;
  protected faSearch = faSearch;
  popupType: string;
  errorMessage: any;
  isToster: boolean = false;
  message: any;
  isLoading  : boolean= false;
  loader : boolean = false;
  endOfResult:  boolean=false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterMakeService: MasterMakeService
  ){
    this.vehicleMakeForm = this.formBuilder.group({
      name: ['', [ Validators.required]],
    });
  }

  ngOnInit(): void {
    this.getVehicleMake();
  }

  getVehicleMake(){
    this.loader = true;
    this.masterMakeService.getMakeDetails(this.filters).subscribe({
      next: (res:any) => {
    this.loader = false;
    if (this.filters.page === 0) {
     this.makeList = res.data;
    }
    if (res.data.length === 0) {
      this.endOfResult = true;
    }
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.loader = false;
    }
    })
  }

  FilterList(searchTerm: any) {
    this.makeList = [];
    this.filters.page = 0;
    this.filters.searchTerm = searchTerm || '';
    this.getVehicleMake();
  }

  vehicleMakeFormPopup(type:string,list?:any){ 
    if(type==='update'){
      this.popupType='Update'
    this.vehicleMakeForm.patchValue(list);
    this.makeId = list._id;
    this.showEditMakePopup = true;
  }else{
    this.popupType='Add'
    this.showEditMakePopup = true;
  }
  }

  onEditSubmit() { 
    this.isLoading = true;
    if (this.popupType==='Update') {
      this.masterMakeService.updateMakeDetails(this.vehicleMakeForm.value,this.makeId).subscribe((res:any) => {
        this.isLoading = false;
        this.getVehicleMake();
        this.closePopup();
        this.isToster = true;
        this.message = res.message;
      })
      
    }else{
      this.masterMakeService.saveVehicleMake(this.vehicleMakeForm.value).subscribe({
      next: (res:any) => {
        this.isLoading = false;
        this.closePopup();
        this.getVehicleMake();
        this.isToster = true;
        this.message = res.message;
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.isLoading = false;
    }
    })
  }
  }

  closePopup() {
    this.showEditMakePopup = false;
    this.vehicleMakeForm.reset()
  }

  closeToster(event: any){
    this.isToster = false;
  }

  loadMore(){
    if (this.endOfResult || this.loader) return;
    this.filters.page++;
    this.getVehicleMake();
  }
}
